// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__JV206","header__content":"styles_header__content__4_hIH","back":"styles_back__8SjmA"};